import React from 'react';

const Innovation1 = () => {
  const cardData = [
    {
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-5_cw3rlj.png",
      date: "March 03, 2025",
      title: "How High Presicision Farming is changing agriculture",
      description: "Smart  farming uses technology such as mobile application to improving production ",
    },
  
  ];

  return (
    <div className="relative bg-white px-4 md:px-20">
      {/* Content */}
      <div className="relative z-10   md:pt-5 pt-2">
        {/* Heading */}
        <div className="mt-4 md:mt-2 md:mb-5">
        <a href='/innovationmain'>
         <h1 className="text-[12px] md:text-[38px] font-bold text-[#FDBD26] ">
          Insights & Innovations
          </h1>
        
         </a>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[620px] h-[250px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          {/* Flex to center the card */}
          <div className="flex justify-center items-center w-full h-full">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="relative w-[40%] h-[90%] md:w-[450px] md:h-[540px] rounded-md overflow-hidden bg-cover bg-center"
                style={{ backgroundImage: `url(${card.image})`, zIndex: 10 }} // Ensure the card is in front
              >
            

            {/* Tag */}
            <div className="absolute md:top-4 md:left-2 top-1 left-1 w-[80px] md:w-[240px] h-[20px] md:h-[50px] flex items-center md:px-4">
              {/* Background layer with blend mode */}
              <div className="absolute inset-0 bg-[#093816] opacity-90 mix-blend-multiply rounded-md"></div>

              {/* Text layer stays normal */}
              <p className="relative text-white text-[6px] md:text-[14px] font-normal z-10">
                Technology & Innovation
              </p>
            </div>


          
              </div>
            ))}
          </div>

          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[70px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
       
        </div>
      </div>
 
      <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[30px]">March 03, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[8px] md:text-[32px] ">How High Presicision Farming is changing agriculture</h3>

{/* Main Text Section */}
<div className="mt-1 space-y-10">
  <p className="text-[8px] md:text-[32px] text-black font-normal">
    Revolutionizing agriculture with digital solutions refers to the use of advanced technologies, software, and data-driven tools to transform traditional farming practices into more efficient, productive, and sustainable systems. Digital solutions in agriculture integrate innovations like big data, artificial intelligence (AI), the Internet of Things (IoT), machine learning, and automation to modernize every aspect of farming, from crop production to livestock management.
    <br /><br />
    Here’s a closer look at how digital solutions are revolutionizing agriculture:
  </p>

  <p className="text-[8px] md:text-[32px] text-black font-normal">
    1. <strong className=' font-normal'>Data-Driven Decision Making</strong><br />
    <strong  className=' font-normal'>Big Data and Analytics:</strong> Farmers now have access to vast amounts of data, including weather patterns, soil conditions, and market trends. By analyzing this data, they can make informed decisions about planting, watering, fertilizing, and harvesting, improving yields and reducing  waste.<br />
    <strong  className=' font-normal'>Predictive Analytics:</strong> Advanced algorithms predict outcomes like crop yield, pest outbreaks, or weather disruptions, helping farmers take proactive steps rather than reactive ones. <br />
    2. <strong  className=' font-normal'>Precision Agriculture</strong><br />
    <strong  className=' font-normal'>GPS Technology:</strong> GPS-enabled tractors and machinery can plant seeds, apply fertilizers, and harvest crops with incredible precision, reducing waste and optimizing resource use.<br />
    <strong  className=' font-normal'>Drones and Satellites:</strong> Drones and satellite imagery help farmers monitor crop health, detect diseases, and identify nutrient deficiencies in real time, allowing for targeted interventions.<br />
    <strong  className=' font-normal'>Variable Rate Technology (VRT):</strong> VRT helps apply water, fertilizers, and pesticides only where needed in specific quantities, reducing overuse and improving crop health. <br/>
    3. <strong  className=' font-normal'>Automation and Robotics</strong><br />
    <strong  className=' font-normal'>Autonomous Machinery:</strong> Tractors, harvesters, and other farming equipment can operate autonomously, performing tasks like plowing, planting, and harvesting with little to no human intervention.<br />
    <strong  className=' font-normal'>Robotic Harvesters:</strong> Robots are being developed to pick fruits and vegetables, reducing labor costs and increasing efficiency, especially for crops that require delicate handling.<br/>
    4. <strong  className=' font-normal'>Internet of Things (IoT)</strong><br />
    <strong  className=' font-normal'>Smart Sensors:</strong> IoT devices can monitor soil moisture, temperature, livestock movement, and more, sending real-time data to farmers’ devices. This helps in efficient resource use and quick action if something goes wrong.


  </p>
<div className='md:h-5 h-2'></div>
</div>
</div>

    </div>
  );
};

export default Innovation1;
